export default {
	addOneTimeMeetingButton: "Add one-time meeting",
	addRecurringMeetingButton: "Add recurring meeting",
	description: "Create scheduled meetings to automate Opre Assistant. When a scheduled meeting approaches, we’ll generate a new note for that meeting and notify you.",
	editOneTimeButton: "Edit",
	editRecurrenceButton: "Edit",
	newOneTimeMeetingButton: "New one-time meeting",
	newRecurringMeetingButton: "New recurrence meeting",
	noOneTimeMeetings: "There are no scheduled one-time meetings.",
	noRecurringMeetings: "There are no scheduled recurring meetings.",
	oneTimeTab: "One-time",
	recurringTab: "Recurring",
	title: "Scheduled meetings",
};
